module.exports = __webpack_public_path__ + "static/media/lid-open-pop.1ee31db5.mp3";